module.exports = __webpack_public_path__ + "static/media/ez_logo_original_rectangular.e2d19507.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ez_logo_original_rectangular.jpg
// module id = 9211
// module chunks = 0